import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { WrappedFieldProps } from 'redux-form';

interface InputField {
  placeholder?: string;
  type?: string;
  title?: string;
  tooltip_id?: string;
  tooltip_text?: string;
}

interface InputGroupProps extends WrappedFieldProps {
  field: InputField;
  disabled?: boolean;
}

const InputGroup: React.FC<InputGroupProps> = ({
  input,
  field: { placeholder, type, title, tooltip_id, tooltip_text },
  meta: { touched, error },
  disabled
}) => {
  const shouldShowErrors = touched || input.value;

  return (
    <div data-cy="form-group" className="form-group">
      {title && (
        <label className="form-control-label mb-1">
          {title}{' '}
          {tooltip_id && tooltip_text && (
            <i id={tooltip_id} className="m-l-5 fa fa-icon fa-question-circle" />
          )}
        </label>
      )}
      {type === 'textarea' ? (
        <textarea
          {...input}
          placeholder={placeholder}
          className={shouldShowErrors && error ? 'form-control is-invalid' : 'form-control'}
          disabled={disabled}
        />
      ) : (
        <input
          data-cy="input"
          {...input}
          placeholder={placeholder}
          type={type}
          className={shouldShowErrors && error ? 'form-control is-invalid' : 'form-control'}
          disabled={disabled}
        />
      )}

      {shouldShowErrors &&
        error &&
        (Array.isArray(error) ? error : [error]).map((errorMsg: string, i: number) => (
          <div key={i} data-cy="invalid-feedback" className="invalid-feedback">
            {errorMsg}
          </div>
        ))}
      {tooltip_id && tooltip_text && (
        <UncontrolledTooltip placement="right" target={tooltip_id}>
          {tooltip_text}
        </UncontrolledTooltip>
      )}
    </div>
  );
};

export default InputGroup;
